import React, { useState, useEffect } from "react";
import moment from "moment"; // Ensure moment is installed or use standard Date if preferred, but existing code uses moment
import styles from "./NewCalendar.module.css";
import { ComplianceCalendar } from "../../../Services/APIrequests";
import { BsCalendarEvent } from "react-icons/bs";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const NewCalendar = () => {
    const [events, setEvents] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUpcomingEvents = async () => {
            try {
                const startMonth = moment().format("YYYY-MM");
                const endMonth = moment().add(3, "months").format("YYYY-MM"); // Fetch next 3 months
                const response = await ComplianceCalendar(startMonth, endMonth);

                if (response.data && response.data.entries) {
                    // Filter events to show only future events + limited count
                    const today = moment();
                    const upcoming = response.data.entries
                        .filter((event) => moment(event.date).isSameOrAfter(today, "day"))
                        .sort((a, b) => moment(a.date) - moment(b.date))
                        .slice(0, 5); // Limit to 5 cards

                    // If API returns standard data, map it. 
                    // Assuming data structure from calender.jsx: { title, description, date, colourCode, ... }
                    setEvents(upcoming);
                }
            } catch (error) {
                console.error("Error fetching calendar events:", error);
            }
        };

        fetchUpcomingEvents();
    }, []);

    const getBadgesColor = (description) => {
        const lower = description?.toLowerCase() || "";
        if (lower.includes("gst")) return { bg: "#d1fae5", color: "#059669" }; // Green for GST
        if (lower.includes("income")) return { bg: "#dbeafe", color: "#2563eb" }; // Blue for Income Tax
        if (lower.includes("labour")) return { bg: "#ffedd5", color: "#ea580c" }; // Orange for Labour Law
        return { bg: "#f3f4f6", color: "#4b5563" };
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <span className={styles.badge}>
                    <BsCalendarEvent style={{ marginRight: '6px' }} /> COMPLIANCE CALENDAR
                </span>
                <h2 className={styles.title}>Stay ahead of every <span style={{ color: 'var(--PrimaryColor)' }}>filing deadline</span></h2>
                <p className={styles.subtitle}>
                    Track GST, Income Tax, Labour Law and other compliance deadlines — so
                    you never pay a late fee again.
                </p>
            </div>

            <div className={styles.grid}>
                {events.map((event, index) => {
                    const date = moment(event.date);
                    // Use categoryName first for tag styling check logic if available, else description/title
                    const tagText = event.categoryName || event.description || "Compliance";
                    const tagStyle = getBadgesColor(tagText);
                    return (
                        <div key={index} className={styles.card}>
                            <div className={styles.dateBox}>
                                <span className={styles.month}>{date.format("MMM").toUpperCase()}</span>
                                <span className={styles.day}>{date.format("DD")}</span>
                            </div>
                            <div className={styles.content}>
                                <h4 className={styles.eventTitle}>{event.title}</h4>
                                {/* API data might not have 'categoryName', checking calender.jsx logic 
                     calender.jsx: event.complianceCalendarUrl ? ...
                     The API response usually has a text description too. */}
                                <span className={styles.tag} style={{ backgroundColor: tagStyle.bg, color: tagStyle.color }}>
                                    {tagText}
                                </span>
                            </div>
                        </div>
                    );
                })}

                {/* 'View Full Calendar' Card */}
                <div className={styles.viewAllCard} onClick={() => navigate("/compliance-calendar")}>
                    {/* Verify route for full calendar? Users existing calendar is in complaints? 
                The user didn't specify a route. I'll use a placeholder or assume existing page.
                Wait, 'calender.jsx' IS the existing component. Home.jsx renders it. 
                I'll leave onClick empty or navigate to section id if it's on same page. */}
                    <div className={styles.viewAllContent}>
                        <BsCalendarEvent size={32} color="var(--PrimaryColor)" style={{ marginBottom: '10px' }} />
                        <span className={styles.viewAllText}>View Full Calendar</span>
                        <FaArrowRight size={14} color="var(--PrimaryColor)" style={{ marginTop: '5px' }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewCalendar;
